import './revision.css'
import React from 'react'

import Header from '../components/shared/header'
import PageTitle from '../components/basic/page-title'
import Steps from '../components/pages/services/steps'
import Button from '../components/basic/button'
import RevisionItem from '../components/pages/revision/revision-item'

import { HiHand, HiOutlinePencil } from "react-icons/hi";

const Revision = () => {
    return (
        <div className="screen-main">

            <Header leftIcon="arrowLeft" label="Agenda" rightIcon="bell" action="/professionals" />

            <Steps Step="4" />


            <PageTitle Title='Confirme seu agendamento' Description='Revise as informações e finalize' />

            <div className="revision-container">
                <RevisionItem Item='Serviço' Description='Corte Feminino' Action='/services'/>
                <div className="revision-line"></div>
                <RevisionItem Item='Profissional' Description='Kaio Kaiano' Action='/professional'/>
                <div className="revision-line"></div>
                <RevisionItem Item='Data' Description='Sexta-feira 19 de junho de 2026'  Action='/time'/>
                <div className="revision-line"></div>
                <RevisionItem Item='Horário' Description='17:40' Action='/time'/>
                <div className="revision-line"></div>
                <RevisionItem Item='Valor' Description='R$ 40,00' Action=''/>
            </div>

            <div className='observation'>
                <span className='app-text'>Observações </span><span className='app-little-text'>(opcional)</span>
            </div>

            <div class="textarea-wrapper">
                <textarea
                    class="textarea-input"
                    placeholder="Adicionar observação..."
                    maxlength="200"
                ></textarea>

                <span class="char-count">0/200</span>
            </div>

            <div className='continue-button'>
                <Button Active='true' Label='Continuar' Icon='calendar' Action='/confirmation' Direction='Next' />
            </div>
        </div>
    )
}

export default Revision